const DateFormat = (dateStr: string): string => {
    const date = new Date(dateStr);

    const month = date.toLocaleString('en-US', {month: 'long'});
    const day = date.getDate();
    const year = date.getFullYear();

    // Function to add ordinal suffix
    const addOrdinalSuffix = (day: number): string => {
        const suffixes = ['th', 'st', 'nd', 'rd'];
        const v = day % 100;
        return day + (suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0]);
    };

    return `${month} ${addOrdinalSuffix(day)} ${year}`;
};

export default DateFormat;
